import z from 'zod';
import { zDateField } from '../utils/date.utils.js';
export const generalLedgerExportSchema = z.object({
    startDate: zDateField('La date de début est requise'),
    endDate: zDateField('La date de fin est requise'),
});
